var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Box, Button, CircularProgress, Input, Typography } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import { Auth } from "aws-amplify";
import React from "react";
import "../styles/AuthStylesheet.css";
import maternaTheme from "../styles/materna_theme";
import { isReservedMattermostUserName, isValidEmailAddress, isValidMattermostUsername, isValidPassword } from "./auth_util";
import AuthComponent, { STATE_SIGN_IN, STATE_SIGN_UP, STATE_SIGN_UP_CONFIRM } from "./AuthComponent";
import { FormattedMessage, injectIntl } from "react-intl";
var VALID_AUTH_STATES = [STATE_SIGN_UP];
var SignUpComponent = /** @class */ (function (_super) {
    __extends(SignUpComponent, _super);
    function SignUpComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.handleFirstNameChange = function (firstName) {
            _this.setState({
                firstName: firstName
            });
        };
        _this.handleLastNameChange = function (lastName) {
            _this.setState({
                lastName: lastName
            });
        };
        _this.handleEmailChange = function (email) {
            _this.setState({
                email: email
            });
        };
        _this.handlePasswordChange = function (password) {
            _this.setState({
                password: password
            });
        };
        _this.handlePasswordConfirmChange = function (password) {
            _this.setState({
                passwordConfirm: password
            });
        };
        _this.onSignInClicked = function () {
            _this.changeAuthState(STATE_SIGN_IN);
        };
        _this.onAccountCreateClicked = function () {
            var error = _this.validateInputs();
            if (error !== null) {
                _this.setState({
                    errorMessage: error
                });
            }
            else {
                _this.setState({
                    errorMessage: "",
                    loading: true,
                    buttonEnabled: false
                });
                Auth.signUp({
                    username: _this.state.email.toLowerCase(),
                    password: _this.state.password,
                    attributes: {
                        "given_name": _this.state.firstName,
                        "family_name": _this.state.lastName,
                        "custom:mattermostusername": _this.state.mattermostName
                    }
                }).then(function () {
                    _this.changeAuthState(STATE_SIGN_UP_CONFIRM, { username: _this.state.email.toLowerCase() });
                }).catch(function (err) {
                    console.error(err);
                    _this.setState({
                        buttonEnabled: true,
                        loading: false,
                        errorMessage: _this.intl.formatMessage({ id: "authentication-default_error_message" }, { errMsg: err.message })
                    });
                });
            }
        };
        _this.state = {
            firstName: "",
            lastName: "",
            mattermostName: "",
            email: "",
            password: "",
            passwordConfirm: "",
            errorMessage: "",
            loading: false,
            buttonEnabled: true
        };
        _this.intl = props.intl;
        return _this;
    }
    // @ts-ignore
    SignUpComponent.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        if (prevProps.authState === STATE_SIGN_IN)
            this.resetState();
    };
    SignUpComponent.prototype.getValidAuthStates = function () {
        return VALID_AUTH_STATES;
    };
    SignUpComponent.prototype.renderComponent = function () {
        return (React.createElement(ThemeProvider, { theme: maternaTheme },
            React.createElement("div", { className: "container" },
                React.createElement("h2", { className: "auth-headline" },
                    React.createElement(FormattedMessage, { id: "authentication-signup_form-header" })),
                React.createElement("form", { autoComplete: "off" },
                    this.renderFirstNameInput(),
                    this.renderLastNameInput(),
                    this.renderEmailInput(),
                    this.renderPasswordInput(),
                    this.renderPasswordRepeatInput(),
                    React.createElement("div", { className: "auth-block" },
                        this.renderError(),
                        this.renderLoading()),
                    this.renderCreateButton(),
                    this.renderBackButton()))));
    };
    SignUpComponent.prototype.renderFirstNameInput = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement("label", { className: "label" },
                this.intl.formatMessage({ id: "authentication-signup_form-first_name" }),
                " *"),
            React.createElement(Box, { width: 300 },
                React.createElement(Input, { className: "input", fullWidth: true, onChange: function (evt) { return _this.handleFirstNameChange(evt.target.value); }, type: "text", placeholder: this.intl.formatMessage({ id: "authentication-signup_form-first_name" }), required: true }))));
    };
    SignUpComponent.prototype.renderLastNameInput = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement("label", { className: "label" },
                this.intl.formatMessage({ id: "authentication-signup_form-last_name" }),
                " *"),
            React.createElement(Box, { width: 300 },
                React.createElement(Input, { className: "input", fullWidth: true, onChange: function (evt) { return _this.handleLastNameChange(evt.target.value); }, type: "text", placeholder: this.intl.formatMessage({ id: "authentication-signup_form-last_name" }), required: true }))));
    };
    SignUpComponent.prototype.renderEmailInput = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement("label", { className: "label" },
                this.intl.formatMessage({ id: "authentication-signup_form-email" }),
                " *"),
            React.createElement(Box, { width: 300 },
                React.createElement(Input, { className: "input", fullWidth: true, onChange: function (evt) { return _this.handleEmailChange(evt.target.value); }, type: "email", value: this.state.email, placeholder: this.intl.formatMessage({ id: "authentication-signup_form-email" }), required: true }))));
    };
    SignUpComponent.prototype.renderPasswordInput = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement("label", { className: "label" },
                this.intl.formatMessage({ id: "authentication-signup_form-password" }),
                " *"),
            React.createElement(Box, { width: 300 },
                React.createElement(Input, { className: "input", fullWidth: true, onChange: function (evt) { return _this.handlePasswordChange(evt.target.value); }, type: "password", placeholder: this.intl.formatMessage({ id: "authentication-signup_form-password" }), required: true }))));
    };
    SignUpComponent.prototype.renderPasswordRepeatInput = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement("label", { className: "label" },
                this.intl.formatMessage({ id: "authentication-signup_form-confirm_password" }),
                " *"),
            React.createElement(Box, { width: 300 },
                React.createElement(Input, { className: "input", fullWidth: true, onChange: function (evt) { return _this.handlePasswordConfirmChange(evt.target.value); }, type: "password", placeholder: this.intl.formatMessage({ id: "authentication-signup_form-confirm_password" }), required: true }))));
    };
    SignUpComponent.prototype.renderLoading = function () {
        if (!this.state.loading)
            return null;
        return (React.createElement("span", { className: "loading-info" },
            React.createElement(CircularProgress, { className: "progress", color: "inherit", size: 20 }),
            React.createElement(FormattedMessage, { id: "authentication-signup_form-processing_msg" })));
    };
    SignUpComponent.prototype.renderError = function () {
        if (this.state.errorMessage === "")
            return null;
        return (React.createElement("p", { className: "error" }, this.state.errorMessage));
    };
    SignUpComponent.prototype.renderCreateButton = function () {
        return (React.createElement(Box, { display: "flex", justifyContent: "center" },
            React.createElement(Button, { variant: "contained", color: "primary", disabled: !this.state.buttonEnabled, className: "button", onClick: this.onAccountCreateClicked },
                React.createElement(FormattedMessage, { id: "authentication-signup_form-create_account" }))));
    };
    SignUpComponent.prototype.renderBackButton = function () {
        return (React.createElement("div", { className: "auth-block" },
            React.createElement(Typography, { className: "auth-text-inline" }, this.intl.formatMessage({ id: "authentication-signup_form-signup_question" })),
            React.createElement("a", { className: "auth-link-inline", onClick: this.onSignInClicked }, this.intl.formatMessage({ id: "authentication-signup_form-signup_link" }))));
    };
    SignUpComponent.prototype.resetState = function () {
        this.setState({
            firstName: "",
            lastName: "",
            mattermostName: "",
            email: "",
            password: "",
            passwordConfirm: "",
            errorMessage: "",
            loading: false,
            buttonEnabled: true
        });
    };
    SignUpComponent.prototype.validateInputs = function () {
        if (this.state.firstName.trim() === "")
            return this.intl.formatMessage({ id: "authentication-signup_form-validation-first_name_missing" });
        if (this.state.lastName.trim() === "")
            return this.intl.formatMessage({ id: "authentication-signup_form-validation-last_name_missing" });
        if (!isValidMattermostUsername(this.state.mattermostName))
            return this.intl.formatMessage({ id: "authentication-signup_form-validation-mattermost_name_invalid" });
        if (isReservedMattermostUserName(this.state.mattermostName))
            return this.intl.formatMessage({ id: "authentication-signup_form-validation-mattermost_name_reserved" });
        if (!isValidEmailAddress(this.state.email))
            return this.intl.formatMessage({ id: "authentication-signup_form-validation-email_invalid" });
        if (this.state.password !== this.state.passwordConfirm)
            return this.intl.formatMessage({ id: "authentication-signup_form-validation-password_mismatch" });
        if (!isValidPassword(this.state.password)) {
            return this.intl.formatMessage({ id: "authentication-signup_form-validation-password_invalid" });
        }
        return null;
    };
    return SignUpComponent;
}(AuthComponent));
export { SignUpComponent };
// @ts-ignore due to injectIntl messing up component signatures
export default injectIntl(SignUpComponent);
//# sourceMappingURL=SignUpComponent.js.map